var _style, _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 19",
    style: {
      enableBackground: "new 0 0 20 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.8,10.9c1.2,0,2.3,0.5,3.1,1.3c0.8,0.8,1.3,1.9,1.4,3.1l0,0.2v0.9c0,0.5-0.2,0.9-0.5,1.2s-0.7,0.5-1.2,0.6 l-0.1,0H1.8c-0.5,0-0.9-0.2-1.2-0.5C0.2,17.4,0,17,0,16.5l0-0.1v-0.9c0-1.2,0.5-2.3,1.3-3.1s1.9-1.3,3.1-1.4l0.2,0H11.8z M8.2,0 c1.2,0,2.4,0.5,3.2,1.3c0.9,0.9,1.3,2,1.3,3.2s-0.5,2.4-1.3,3.2c-0.9,0.9-2,1.3-3.2,1.3S5.8,8.6,5,7.8c-0.9-0.9-1.3-2-1.3-3.2 S4.1,2.2,5,1.3C5.8,0.5,7,0,8.2,0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.4,
    y: 5.5,
    className: "st0",
    width: 1.8,
    height: 5.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 7.3,
    className: "st0",
    width: 5.5,
    height: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.2556b1e5c88ad15efa3b71487dfa3c22.svg";
export { ForwardRef as ReactComponent };